import { useTranslation } from 'react-i18next'
import type { DocumentFragment } from '~app/graph/generated/graphql'
import { NO_CUSTOMER } from '../home/constants'

interface Props {
  customer?: DocumentFragment['customer']
}

const DocumentOwnerPreview = (props: Props) => {
  const { t } = useTranslation()

  const customer = props.customer ?? NO_CUSTOMER
  return (
    <div>
      <h4>{t('titles.customerDetails')}</h4>
      <b>{`${customer.id} ${customer.firstName} ${customer.lastName}`}</b>
    </div>
  )
}

export default DocumentOwnerPreview
